module.exports = __webpack_public_path__ + "img/Flag_of_Iceland.1310d11c.svg";